import { UserRole } from '../account';

export enum FieldType {
  text = 'text',
  autocomplete = 'autocomplete',
  largetext = 'largetext',
  numerical = 'numerical',
  multiOptions = 'multiOptions',
  singleOption = 'singleOption',
  phone = 'phone',
  dropdown = 'dropdown',
  datepicker = 'datepicker',
  address = 'address',
  file = 'file',
  html = 'html',
}
export type FieldId = string;

export interface SettingFieldDetailResponse {
  objectId?: number | null;
  value: string;
}

export interface SettingFieldResponse {
  id: FieldId;
  for: 'people' | 'organizations' | 'deals' | 'users';
  type: FieldType;
  label: string;
  isNewDialog: boolean;
  required: boolean;
  filter: boolean;
  values: SettingFieldOptionResponse[];
  details: SettingFieldOptionResponse[];
  value?: string;
  whichRole?: UserRole;
}

export interface SettingFieldOptionResponse {
  objectId?: number | null;
  fieldId: FieldId;
  value: string;
  menuOrder: number;
}
